var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75003 18.4375C3.74815 18.6839 3.84407 18.9209 4.01673 19.0967C4.1894 19.2724 4.42472 19.3725 4.67108 19.375H15.329C15.5753 19.3725 15.8107 19.2724 15.9833 19.0967C16.156 18.9209 16.2519 18.6839 16.25 18.4375V5.9375H3.75003V18.4375ZM5.00003 7.1875H15V18.125H5.00003V7.1875Z",
    stroke: "currentColor",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 8.4375H7.8125V16.25H6.5625V8.4375Z",
    stroke: "currentColor",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.4375H10.625V16.25H9.375V8.4375Z",
    stroke: "currentColor",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 8.4375H13.4375V16.25H12.1875V8.4375Z",
    stroke: "currentColor",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 3.4375V1.5625C12.8125 1.0368 12.4419 0.625 11.9688 0.625H8.03125C7.55813 0.625 7.1875 1.0368 7.1875 1.5625V3.4375H2.5V4.6875H17.5V3.4375H12.8125ZM8.4375 1.875H11.5625V3.4375H8.4375V1.875Z",
    stroke: "currentColor",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.573ebc899f9aab964a6be958a1731b29.svg";
export { ForwardRef as ReactComponent };